class ConstantVar {
  DIVISION_LIST = 14;

  LOADING_INTI = true;

  LOADING_END = false;

  MAX_DOWNLOAD = 20;

  DEFAULT_PASSWORD = 12345;

  LIST_APPLICANT_SHOW = [20, 50, 100, 200];

  LOADING_MODEL = {
    process_loading: false,
    loading_text: null,
  };

  DATE_MASK = {
    date_option: { mask: "####/##/##", eager: true },
    placeholder: "YYYY/mm/dd",
    ym_option: { mask: "####/##", eager: true },
    ym_placeholder: "YYYY/mm",
  };

  REG_CONST = {
    min_age: 17,
    max_age: 61,
    img_maxSize: 5 * 1024 * 1024, // 5MB in bytes
    file_maxSize: 5 * 1024 * 1024, // 5MB in bytes
    allowedFileTypes: ["image/jpeg", "image/jpg", "image/png"],
  };

  APPLICANT_MAX_LENGTH = {
    name_jp: 45,
    name_eng: 45,
    nrc_no: 6,
    age: 2,
    birth_state: 300,
    birth_city: 300,
    residence_address: 300,
    present_addr: 300,
    race: 45,
    cellphone: 15,
    strength_weakness: 150,
    edu_school: 100,
    work_organization: 100,
    work_position: 45,
    family_name: 45,
    family_relation: 45,
    family_work_place: 100,
    family_occupation: 50,
    edu_qualifications: 300,
    passport_no: 10,
    qualification: 100,
    annual_saving_goal: 10,
    height_weight: 3,
    eyes: 6,
    year: 4,
    salary: 10,
    remark: 500,
  };

  USER_MAX_LENGTH = {
    uid: 18,
    name: 45,
    email: 45,
  };

  JOB_REG_MAX_LENGTH = {
    name: 100,
  };

  SET_INTERVIEW_MAX_LENGTH = {
    sup_org: 45,
    imp_org: 45,
  };

  TRAVEL_COUNTRY = [
    { en: "India", ja: "インド" },
    { en: "Maldives", ja: "モルディブ" },
    { en: "UAE", ja: "ドバイ等" },
    { en: "Singapore", ja: "シンガポール" },
    { en: "Thailand", ja: "タイ" },
    { en: "Malaysia", ja: "マレーシア" },
    { en: "United Kingdom", ja: "英国" },
    { en: "Australia", ja: "オーストラリア" },
    { en: "Japan", ja: "日本" },
    { en: "Other", ja: "その他" },
  ];

  LANGUAGE = [
    { en: "Sinhala", ja: "シンハラ語" },
    { en: "Tamil", ja: "タミル語" },
    { en: "English", ja: "英語" },
    { en: "Korean", ja: "韓国語" },
    { en: "Chinese", ja: "中国語" },
    { en: "Vietnamese", ja: "ベトナム語" },
    { en: "Islamic language", ja: "イスラム語" },
    { en: "Arabic", ja: "アラビア語" },
    { en: "Urdu", ja: "ウルドゥー語" },
    { en: "Japanese", ja: "日本語" },
    { en: "Tagalog", ja: "タガログ語" },
    { en: "Other Languages", ja: "その他言語" },
  ];

  STATE = [
    { id: 0, en: "Western", ja: "西部" },
    { id: 1, en: "Central", ja: "中央" },
    { id: 2, en: "Southern", ja: "南部" },
    { id: 3, en: "Northern", ja: "北部" },
    { id: 4, en: "Eastern", ja: "東部" },
    { id: 5, en: "North Western", ja: "北西部" },
    { id: 6, en: "North Central", ja: "北中部" },
    { id: 7, en: "Uva", ja: "ウバ" },
    { id: 8, en: "Sabaragamuwa", ja: "サバラガムワ" },
  ];

  CITY = {
    0: [
      { en: "Colombo", ja: "コロンボ" },
      { en: "Gampaha", ja: "ガンパハ" },
      { en: "Kalutara", ja: "カルタラ" },
    ],
    1: [
      { en: "Kandy", ja: "キャンディ" },
      { en: "Matale", ja: "マータレー" },
      { en: "Nuwara Eliya", ja: "ヌワラエリヤ" },
    ],
    2: [
      { en: "Galle", ja: "ガール" },
      { en: "Matara", ja: "マータラ" },
      { en: "Hambantota", ja: "ハンバントゥタ" },
    ],
    3: [
      { en: "Jaffna", ja: "ジャフナ" },
      { en: "Kilinochchi", ja: "キリノッチ" },
      { en: "Mannar", ja: "マナー" },
      { en: "Vavuniya", ja: "ヴァヴニヤ" },
      { en: "Mullaitivu", ja: "ムライティブ" },
    ],
    4: [
      { en: "Trincomalee", ja: "トリンコマリー" },
      { en: "Batticaloa", ja: "バッティカロア" },
      { en: "Ampara", ja: "アンパラ" },
    ],
    5: [
      { en: "Kurunegala", ja: "クルネーガラ" },
      { en: "Puttalam", ja: "プッタラム" },
    ],
    6: [
      { en: "Anuradhapura", ja: "アヌラーダプラ" },
      { en: "Polonnaruwa", ja: "ポロンナルワ" },
    ],
    7: [
      { en: "Badulla", ja: "バドゥッラ" },
      { en: "Monaragala", ja: "モナラーグラ" },
    ],
    8: [
      { en: "Kegalle", ja: "ケーガッラ" },
      { en: "Ratnapura", ja: "ラトゥナプラ" },
    ],
  };

  QUALIFICATION_CATEGORY = [
    { value: "japanese", ja: "日本語資格", en: "Japanese Qualification" },
    { value: "ssw", ja: "特定技能資格", en: "Specific Skilled Worker" },
    { value: "other", ja: "その他資格", en: "Other Qualification" },
    { value: "IQTest", ja: "IQテストの点数", en: "IQ Test Scores" },
  ];

  QUALIFICATION_STATUS = [
    { value: "Passed", ja: "合格", en: "Passed" },
    { value: "Failed", ja: "不合格", en: "Failed" },
    { value: "Studying", ja: "勉強中", en: "Studying" },
  ];

  QUALIFICATION_OPTIONS = {
    /* ================= 日本語資格 ================= */
    japanese: [
      { en: "JLPT-TEST N1", ja: "日本語能力試験 JLPT-N1" },
      { en: "JLPT-TEST N2", ja: "日本語能力試験 JLPT-N2" },
      { en: "JLPT-TEST N3", ja: "日本語能力試験 JLPT-N3" },
      { en: "JLPT-TEST N4", ja: "日本語能力試験 JLPT-N4" },
      { en: "JLPT-TEST N5", ja: "日本語能力試験 JLPT-N5" },

      { en: "NAT-TEST 1Q", ja: "日本語NAT-TEST 1Q" },
      { en: "NAT-TEST 2Q", ja: "日本語NAT-TEST 2Q" },
      { en: "NAT-TEST 3Q", ja: "日本語NAT-TEST 3Q" },
      { en: "NAT-TEST 4Q", ja: "日本語NAT-TEST 4Q" },
      { en: "NAT-TEST 5Q", ja: "日本語NAT-TEST 5Q" },

      { en: "JFT-A1", ja: "国際交流基金日本語基礎テスト JFT-A1" },
      { en: "JFT-A2", ja: "国際交流基金日本語基礎テスト JFT-A2" },
      { en: "JFT-B1", ja: "国際交流基金日本語基礎テスト JFT-B1" },
      { en: "JFT-B2", ja: "国際交流基金日本語基礎テスト JFT-B2" },
      { en: "JFT-C1", ja: "国際交流基金日本語基礎テスト JFT-C1" },
      { en: "JFT-C2", ja: "国際交流基金日本語基礎テスト JFT-C2" },

      { en: "J.TEST A", ja: "実用日本語検定 J.TEST A" },
      { en: "J.TEST B", ja: "実用日本語検定 J.TEST B" },
      { en: "J.TEST C", ja: "実用日本語検定 J.TEST C" },
      { en: "J.TEST D", ja: "実用日本語検定 J.TEST D" },
      { en: "J.TEST E", ja: "実用日本語検定 J.TEST E" },
      { en: "J.TEST F", ja: "実用日本語検定 J.TEST F" },
      { en: "J.TEST G", ja: "実用日本語検定 J.TEST G" },

      { en: "J-Cert A1", ja: "J-Cert生活・職能日本語検定 A1" },
      { en: "J-Cert A2.1", ja: "J-Cert生活・職能日本語検定 A2.1" },
      { en: "J-Cert A2.2", ja: "J-Cert生活・職能日本語検定 A2.2" },
      { en: "J-Cert B1", ja: "J-Cert生活・職能日本語検定 B1" },
      { en: "J-Cert B2", ja: "J-Cert生活・職能日本語検定 B2" },
      { en: "J-Cert C1", ja: "J-Cert生活・職能日本語検定 C1" },
      { en: "J-Cert C2", ja: "J-Cert生活・職能日本語検定 C2" },

      { en: "TopJ Advanced A", ja: "TOPJ 実用日本語運用能力試験 上級A" },
      { en: "TopJ Advanced B", ja: "TOPJ 実用日本語運用能力試験 上級B" },
      { en: "TopJ Advanced C", ja: "TOPJ 実用日本語運用能力試験 上級C" },
      { en: "TopJ Intermediate A", ja: "TOPJ 実用日本語運用能力試験 中級A" },
      { en: "TopJ Intermediate B", ja: "TOPJ 実用日本語運用能力試験 中級B" },
      { en: "TopJ Intermediate C", ja: "TOPJ 実用日本語運用能力試験 中級C" },
      { en: "TopJ Beginner A-4", ja: "TOPJ 実用日本語運用能力試験 初級A-4" },
      { en: "TopJ Beginner A-5", ja: "TOPJ 実用日本語運用能力試験 初級A-5" },
      { en: "TopJ Beginner B", ja: "TOPJ 実用日本語運用能力試験 初級B" },

      { en: "JFT-Basic", ja: "国際交流基金日本語基礎テスト(JFT-Basic)" },
      { en: "EJU", ja: "EJU日本留学試験" },
      { en: "IELTS", ja: "IELTS" },
      { en: "TOEFL", ja: "TOEFL" },
      { en: "TOEIC", ja: "TOEIC" },
      { en: "GCE", ja: "GCE" },

      { en: "Other", ja: "その他" },
    ],

    /* ================= 特定技能資格 ================= */
    ssw: [
      { en: "Tokutei Nursing Care Skills", ja: "介護特定技能評価試験" },
      { en: "Tokutei Food Service Industry", ja: "外食業特定技能測定試験" },
      { en: "Tokutei Agriculture Skills", ja: "農業技能測定試験" },
      {
        en: "Tokutei Food and beverage Manufacturing",
        ja: "飲食料品製造業技能測定試験",
      },
      {
        en: "Tokutei Automobile repair and maintenance field",
        ja: "自動車整備分野特定技能評価試験",
      },
      {
        en: "Tokutei Fishing industry Skills (Aquaculture)",
        ja: "漁業技能測定試験(養殖業)",
      },
      {
        en: "Tokutei Fishing industry skills (fishery)",
        ja: "漁業技能測定試験(漁業)",
      },
      { en: "Tokutei Construction Field", ja: "建設分野特定技能評価試験" },
      {
        en: "Tokutei Accommodation Industry",
        ja: "宿泊分野特定技能1号評価試験",
      },
      { en: "Tokutei Industrial Product", ja: "製造分野特定技能評価試験" },
      {
        en: "Tokutei Building Cleaning",
        ja: "ビルクリーニング特定技能評価試験",
      },
      {
        en: "Tokutei Shipbuilding and ship machinery industries",
        ja: "造船・舶用工業分野特定技能評価試験",
      },
      { en: "Tokutei Aviation Industry", ja: "特定技能評価試験（航空分野）" },
      {
        en: "Tokutei Automobile Transportation business",
        ja: "自動車運送業分野特定技能評価試験",
      },
      { en: "Tokutei Railway", ja: "鉄道分野特定技能評価試験" },
      { en: "Tokutei Forestry", ja: "林業技能測定試験" },
      { en: "Tokutei Wood Industry", ja: "木材産業特定技能測定試験" },
      { en: "Other", ja: "その他" },
    ],

    /* ================= その他資格 ================= */
    other: [
      { en: "Driving License", ja: "普通自動車運転免許" },
      { en: "Forklift License", ja: "フォークリフト免許" },
      { en: "Crane and Derrick Operator", ja: "クレーン・デリック運転士" },
      { en: "Mobile Crane Operator", ja: "移動式クレーン運転士" },
      { en: "Slinging Operator", ja: "玉掛技能者" },
      { en: "Automobile mechanic License", ja: "自動車整備士" },
      { en: "Childcare Worker", ja: "保育士" },
      { en: "Nurse", ja: "看護師" },
      { en: "Chef / Pastry Chef", ja: "調理師・パティシエ" },
      { en: "Care Giver", ja: "介護士" },
      { en: "Midwife", ja: "助産師" },
      { en: "Babysitter", ja: "ベビーシッター" },
      { en: "Japanese Language Teacher", ja: "日本語教師" },
      { en: "Chiropractor / Therapist", ja: "整体・セラピスト" },
      { en: "Sports Trainer", ja: "スポーツトレーナー" },
      { en: "Web Designer", ja: "Webデザイナー" },
      { en: "IT Engineer", ja: "ITエンジニア" },
      { en: "CAD", ja: "CAD" },
      { en: "Video Editing", ja: "動画編集" },
      { en: "Computer Technician", ja: "パソコン整備士" },
      { en: "Fashion Designer", ja: "ファッションデザイナー" },
      { en: "Beautician", ja: "美容師" },
      { en: "Patent Attorney", ja: "弁理士" },
      { en: "Administrative Scrivener", ja: "行政書士" },
      { en: "Other", ja: "その他" },
    ],
  };

  RACE = [
    { en: "Sinhala", ja: "シンハラ" },
    { en: "Tamil", ja: "タミル" },
    { en: "Sri Lankan Moor", ja: "スリランカ・ムーア" },
    { en: "Burgher", ja: "バーガー" },
    { en: "Malay", ja: "マレー" },
  ];

  REFERAL_SCHOOL = ["DSGC", "Dream J", "Other"];
  REFERRAL_SCHOOL = this.REFERAL_SCHOOL;
}
export default ConstantVar;
